import type { ReactNode } from "react";
import { Navigate } from "react-router";

import { useAuth } from "@/hooks/useAuth";
import { isComplianceEnabled } from "@/lib/features";

/**
 * Route guard for the Policies feature (BE #898). While the backend reports
 * `features.compliance` off (or omits it), a direct URL to a policy route
 * redirects to the dashboard.
 */
export const ComplianceRoute = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  if (!isComplianceEnabled(user)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};
